import React, { useState, useEffect, useRef, ChangeEvent } from "react";
import Header from "../../../components/molecules/Header/Header";
import Banner from "../../../components/layout/Sections/Banner";
import { Container, Row, Col } from "react-bootstrap";
import Footer from "../../../components/molecules/Footer/Footer";
import { getCountries } from "../../../api/apimethods";
import "../../../styles/styles.css";
import ReCAPTCHA from "react-google-recaptcha";
import { useConfig } from "../../../context/ConfigProvider";
import { ICodeMasterModel } from "../../../../src/typings/models/CodeMasterModel";
function ApplicationForImportPermit() {
  const bannerName = "Application For Import Permit (Individual / Parcels)";
  const [applicantType, setApplicantType] = useState<string>("");
  const [selectedTitle, setSelectedTitle] = useState<string>("");
  const [importerName, setImporterName] = useState<string>("");
  const allowedExtensions = [
    "pdf",
    "docx",
    "doc",
    "jpg",
    "jpeg",
    "png",
    "xlsx",
    "xls",
  ];
  const [PcFromOrigin, setPcFromOrigin] = useState<File | null>(null);
  const [applicantName, setApplicantName] = useState<string>("");
  const [identificationType, setIdentificationType] = useState<string>("");
  const [identificationNumber, setIdentificationNumber] = useState<string>("");
  const [Invoice, setInvoice] = useState<File | null>(null);

  const [uenNumber, setUenNumber] = useState<string>("");
  const [error, seterror] = useState<string>("");
  const [citizenship, setCitizenship] = useState<string>("");
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [gender, setGender] = useState<string>("");
  const [dateOfBirth, setDateOfBirth] = useState<string>("");
  const [designation, setDesignation] = useState<string>("");
  const [officeTelNumber, setOfficeTelNumber] = useState<string>("");
  const [homeTelNumber, setHomeTelNumber] = useState<string>("");
  const [mobileNumber, setMobileNumber] = useState<string>("");
  const [exporterName, setExporterName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [primaryContactMode, setPrimaryContactMode] = useState<string>("");
  const [receiveStatusUpdates, setReceiveStatusUpdates] =
    useState<boolean>(false);
  const [personalAddressType, setPersonalAddressType] = useState<string>("");
  const [typeOfPremises, setTypeOfPremises] = useState<string>("");
  const [blockHouseNum, setBlockHouseNum] = useState<string>("");
  const [streetName, setStreetName] = useState<string>("");
  const [floorNumber, setFloorNumber] = useState<string>("");
  const [unitNumber, setUnitNumber] = useState<string>("");
  const [buildingName, setBuildingName] = useState<string>("");
  const [postalCode, setPostalCode] = useState<string>("");
  const [country, setCountry] = useState<string>("");
  const [state, setState] = useState<string>("");
  const [countries, setCountries] = useState<ICodeMasterModel[]>([]);
  const [consignmentDescription, setConsignmentDescription] =
    useState<string>("");
  const [category, setCategory] = useState<string>("");
  const [botanicalNames, setBotanicalNames] = useState<string[]>([""]);
  const [quantity, setQuantity] = useState<string>("");
  const [unitOfMeasurements, setUnitOfMeasurements] = useState<string>("");
  const [countryOfOrigin, setCountryOfOrigin] = useState<string>("");
  const [parcelReferences, setParcelReferences] = useState<string[]>([""]);
  const [arrivalDate, setArrivalDate] = useState<string>("");
  const [isCaptchaValid, setIsCaptchaValid] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const cfg = useConfig();
  const site_Key: string = cfg.REACT_APP_SITE_KEY ?? "";
  const handleApplicantTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setApplicantType(event.target.value);
  };

  const handleTitleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedTitle(event.target.value);
  };

  const handleImporterNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setImporterName(event.target.value);
  };
  const handleCitizenshipChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setCitizenship(event.target.value);
  };
  const handleFileChange = (
    event: ChangeEvent<HTMLInputElement>,
    setFileState: React.Dispatch<React.SetStateAction<File | null>>
  ) => {
    const fileInput = event.target;
    if (fileInput && fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];
      const fileExtension = file.name.split(".").pop()?.toLowerCase();

      if (fileExtension && allowedExtensions.includes(fileExtension)) {
        setFileState(file);
        setErrorMessage("");
      } else {
        setFileState(null);
        setErrorMessage(
          `Invalid file extension. Allowed extensions are: ${allowedExtensions.join(
            ", "
          )}`
        );
      }
    } else {
      setFileState(null);
      setErrorMessage("No file selected");
    }
  };

  const handleIdentificationTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIdentificationType(event.target.value);
  };
  const handleIdentificationNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setIdentificationNumber(event.target.value);
  };
  const handleExporterNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setExporterName(event.target.value);
  };
  const handleUENNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setUenNumber(event.target.value);
  };
  const getFormattedCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
    return formattedDateTime;
  };
  const isDateValid = (selectedDate: string): boolean => {
    const currentDate = new Date();
    const maxAllowedDate = new Date(currentDate);
    maxAllowedDate.setDate(currentDate.getDate() + 2);
    const dateToCompare = new Date(selectedDate);

    return dateToCompare >= currentDate && dateToCompare <= maxAllowedDate;
  };
  const handleGenderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setGender(event.target.value);
  };
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await getCountries();

        setCountries(response.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  const handleDateOfBirthChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDateOfBirth(event.target.value);
  };

  const handleDesignationChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setDesignation(event.target.value);
  };

  const handleOfficeTelNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setOfficeTelNumber(event.target.value);
  };

  const handleHomeTelNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setHomeTelNumber(event.target.value);
  };

  const handleMobileNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setMobileNumber(event.target.value);
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handlePrimaryContactModeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPrimaryContactMode(event.target.value);
  };

  const handleStatusUpdatesCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setReceiveStatusUpdates(event.target.checked);
  };

  const handlePersonalAddressTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPersonalAddressType(event.target.value);
  };

  const handleTypeOfPremisesChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTypeOfPremises(event.target.value);
  };

  const handleBlockHouseNumChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setBlockHouseNum(event.target.value);
  };

  const handleStreetNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setStreetName(event.target.value);
  };

  const handleFloorNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFloorNumber(event.target.value);
  };

  const handleUnitNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setUnitNumber(event.target.value);
  };

  const handleBuildingNameChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setBuildingName(event.target.value);
  };

  const handlePostalCodeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPostalCode(event.target.value);
  };

  const handleCountryChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setCountry(event.target.value);
  };

  const handleStateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState(event.target.value);
  };
  const handleConsignmentDescriptionChange: React.ChangeEventHandler<
    HTMLTextAreaElement
  > = (event) => {
    setConsignmentDescription(event.target.value);
  };

  const handleCategoryChange: React.ChangeEventHandler<HTMLSelectElement> = (
    event
  ) => {
    setCategory(event.target.value);
  };

  const handleBotanicalNameChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const updatedBotanicalNames = [...botanicalNames];
    updatedBotanicalNames[index] = event.target.value;
    setBotanicalNames(updatedBotanicalNames);
  };

  const addBotanicalNameField = () => {
    setBotanicalNames([...botanicalNames, ""]);
  };

  const handleQuantityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setQuantity(event.target.value);
  };

  const handleUnitOfMeasurementsChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setUnitOfMeasurements(event.target.value);
  };

  const handleCountryOfOriginChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setCountryOfOrigin(event.target.value);
 
  };

  const handleParcelReferenceChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const updatedParcelReferences = [...parcelReferences];
    updatedParcelReferences[index] = event.target.value;
    setParcelReferences(updatedParcelReferences);
  };

  const addParcelReferenceField = () => {
    setParcelReferences([...parcelReferences, ""]);
  };

  const handleArrivalDateChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setArrivalDate(event.target.value);
  };
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isCaptchaValid) {
    } else {
      console.log(error);
    }
  };

  return (
    <>
      <Header />
      <Container>
        <Banner name={bannerName} uiClass="banner-bg" />
      </Container>
      <Container>
        <Row>
          <Col md={2}>
            <div className="filter-cntt">
              <h3>E-Services</h3>
              <div className="filter-span">Application Details</div>
              <h2>Registration Mode</h2>
              <button title="Dashboard">Dashboard</button>
            </div>
          </Col>

          <Col md={10}>
            <form onSubmit={handleSubmit}>
              <div className="inst-cntt mt-2">
                <label htmlFor="applicantType">
                  <h2>Importer Details</h2>
                  Applicant Type<span className="star-red">*</span>
                </label>
                <div className="form-checked">
                  <label className="form-check-label" htmlFor="individualRadio">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="individualRadio"
                      name="applicantType"
                      value="individual"
                      onChange={handleApplicantTypeChange}
                      required
                    />
                    Individual
                  </label>
                </div>
                <div className="form-checked">
                  <label
                    className="form-check-label"
                    htmlFor="organizationRadio"
                  >
                    <input
                      type="radio"
                      className="form-check-input"
                      id="organizationRadio"
                      name="applicantType"
                      value="organization"
                      onChange={handleApplicantTypeChange}
                      required
                    />
                    Organization
                  </label>
                </div>
                <label htmlFor="title">
                  Select a Salutation<span className="star-red">*</span>
                </label>
                <select
                  id="title"
                  name="title"
                  value={selectedTitle}
                  className="form-controll"
                  onChange={handleTitleChange}
                  required
                >
                  <option value="" disabled hidden>
                    Choose a Salutation
                  </option>
                  <option value="Dr">Dr</option>
                  <option value="Mdm">Mdm</option>
                  <option value="Miss">Miss</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                </select>
                <label htmlFor="importerName">
                  Applicant Name<span className="star-red">*</span>
                </label>
                <input
                  type="text"
                  id="importerName"
                  name="importerName"
                  className="form-controll"
                  value={importerName}
                  onChange={handleImporterNameChange}
                  maxLength={255}
                  required
                />
                <br />
                <label htmlFor="Identification Type">
                  Identification Type<span className="star-red">*</span>
                </label>
                <div className="form-checked">
                  <label className="form-check-label" htmlFor="nricRadio">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="nricRadio"
                      name="identificationType"
                      value="NRIC"
                      onChange={handleIdentificationTypeChange}
                      required
                    />
                    NRIC
                  </label>
                </div>
                <div className="form-checked">
                  <label className="form-check-label" htmlFor="finRadio">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="finRadio"
                      name="identificationType"
                      value="FIN"
                      onChange={handleIdentificationTypeChange}
                      required
                    />
                    FIN
                  </label>
                </div>
                <div className="form-checked">
                  <label className="form-check-label" htmlFor="passportRadio">
                    <input
                      type="radio"
                      className="form-check-input"
                      id="passportRadio"
                      name="identificationType"
                      value="Passport No"
                      onChange={handleIdentificationTypeChange}
                      required
                    />
                    Passport No
                  </label>
                </div>
                <div>
                  <label htmlFor="importerName">
                    Identification Number<span className="star-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="identificationNumber"
                    name="identificationNumber"
                    value={identificationNumber}
                    className="form-controll"
                    onChange={handleIdentificationNumberChange}
                    maxLength={9}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="importerName">UEN Number</label>
                  <input
                    id="uenNumber"
                    name="uenNumber"
                    value={uenNumber}
                    className="form-controll"
                    onChange={handleUENNumberChange}
                    maxLength={9}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="importerName">
                    Citizenship<span className="star-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="citizenship"
                    name="citizenship"
                    value={citizenship}
                    className="form-controll"
                    onChange={handleCitizenshipChange}
                    maxLength={255}
                    required
                  />
                </div>
                <div>
                  <label>
                    Gender<span className="star-red">*</span>
                  </label>
                  <div className="form-checked">
                    <label className="form-check-label" htmlFor="maleRadio">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="maleRadio"
                        name="gender"
                        value="Male"
                        onChange={(e) => setGender(e.target.value)}
                        required
                      />
                      Male
                    </label>
                  </div>
                  <div className="form-checked">
                    <label className="form-check-label" htmlFor="femaleRadio">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="femaleRadio"
                        name="gender"
                        value="Female"
                        onChange={(e) => setGender(e.target.value)}
                        required
                      />
                      Female
                    </label>
                  </div>
                </div>
                <div>
                  <label htmlFor="dateOfBirth">
                    Date of Birth<span className="star-red">*</span>
                  </label>
                  <input
                    type="date"
                    id="dateOfBirth"
                    name="dateOfBirth"
                    value={dateOfBirth}
                    onChange={(e) => setDateOfBirth(e.target.value)}
                    className="form-controll"
                    required
                  />
                </div>
                <div>
                  <label>Designation</label>
                  <div className="form-checked">
                    <label className="form-check-label" htmlFor="listRadio">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="listRadio"
                        name="designation"
                        value="List of Designations"
                        onChange={(e) => setDesignation(e.target.value)}
                        required
                      />
                      List of Designations
                    </label>
                  </div>
                  <div className="form-checked">
                    <label className="form-check-label" htmlFor="othersRadio">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="othersRadio"
                        name="designation"
                        value="Others"
                        onChange={(e) => setDesignation(e.target.value)}
                        required
                      />
                      Others
                    </label>
                  </div>
                </div>{" "}
                <div>
                  <label htmlFor="officeTelNumber">Office Tel Number</label>
                  <input
                    type="tel"
                    id="officeTelNumber"
                    name="officeTelNumber"
                    value={officeTelNumber}
                    onChange={(e) => setOfficeTelNumber(e.target.value)}
                    className="form-controll"
                    maxLength={16}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="homeTelNumber">Home Tel Number</label>
                  <input
                    type="tel"
                    id="homeTelNumber"
                    name="homeTelNumber"
                    value={homeTelNumber}
                    onChange={(e) => setHomeTelNumber(e.target.value)}
                    className="form-controll"
                    maxLength={16}
                    required
                  />
                </div>{" "}
                <div>
                  <label htmlFor="mobileNumber">
                    Mobile Number<span className="star-red">*</span>
                  </label>
                  <input
                    type="tel"
                    id="mobileNumber"
                    name="mobileNumber"
                    value={mobileNumber}
                    onChange={(e) => setMobileNumber(e.target.value)}
                    className="form-controll"
                    maxLength={16}
                    required
                  />
                </div>{" "}
                <div>
                  <label htmlFor="email">
                    Email<span className="star-red">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="form-controll"
                    maxLength={255}
                    required
                  />
                </div>
                <div>
                  <label>
                    Primary Contact Mode<span className="star-red">*</span>
                  </label>
                  <div className="form-checked">
                    <label className="form-check-label" htmlFor="mobileRadio">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="mobileRadio"
                        name="primaryContactMode"
                        value="Mobile Number"
                        onChange={(e) => setPrimaryContactMode(e.target.value)}
                        required
                      />
                      Mobile Number
                    </label>
                  </div>
                  <div className="form-checked">
                    <label className="form-check-label" htmlFor="emailRadio">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="emailRadio"
                        name="primaryContactMode"
                        value="Email"
                        onChange={(e) => setPrimaryContactMode(e.target.value)}
                        required
                      />
                      Email
                    </label>
                  </div>
                </div>{" "}
                <label>
                  <input
                    type="checkbox"
                    checked={receiveStatusUpdates}
                    onChange={(e) => setReceiveStatusUpdates(e.target.checked)}
                  />
                  &nbsp; Tick if you prefer to receive status updates of license
                  application via SMS
                </label>
              </div>

              <div className="inst-cntt">
                <h2 className=".tab-content">Importer Personal Address</h2>
                <div className="form-controll">
                  <label>
                    Personal Address Type<span className="star-red">*</span>
                  </label>
                  <div className="form-checked">
                    <label className="form-check-label" htmlFor="localRadio">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="localRadio"
                        name="personalAddressType"
                        value="Local"
                        onChange={handlePersonalAddressTypeChange}
                        required
                      />
                      Local
                    </label>
                  </div>
                  <div className="form-checked">
                    <label className="form-check-label" htmlFor="foreignRadio">
                      <input
                        type="radio"
                        className="form-check-input"
                        id="foreignRadio"
                        name="personalAddressType"
                        value="Foreign"
                        onChange={handlePersonalAddressTypeChange}
                        required
                      />
                      Foreign
                    </label>
                  </div>
                </div>

                <div>
                  <div className="mt-2">
                    <label>
                      Type of Premises<span className="star-red">*</span>
                    </label>
                    <div className="form-checked">
                      <label className="form-check-label" htmlFor="officeRadio">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="officeRadio"
                          name="typeOfPremises"
                          value="Office"
                          onChange={handleTypeOfPremisesChange}
                          required
                        />
                        Office
                      </label>
                    </div>
                    <div className="form-checked">
                      <label className="form-check-label" htmlFor="homeRadio">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="homeRadio"
                          name="typeOfPremises"
                          value="Home"
                          onChange={handleTypeOfPremisesChange}
                          required
                        />
                        Home
                      </label>
                    </div>
                    <div className="form-checked">
                      <label className="form-check-label" htmlFor="othersRadio">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="othersRadio"
                          name="typeOfPremises"
                          value="Others"
                          onChange={handleTypeOfPremisesChange}
                          required
                        />
                        Others
                      </label>
                    </div>
                  </div>
                </div>

                <div>
                  <label htmlFor="blockHouseNum">
                    Block/House Num<span className="star-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="blockHouseNum"
                    name="blockHouseNum"
                    value={blockHouseNum}
                    onChange={handleBlockHouseNumChange}
                    className="form-controll"
                    maxLength={10}
                    required
                  />
                </div>

                <div>
                  <label htmlFor="streetName">
                    Street Name<span className="star-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="streetName"
                    name="streetName"
                    value={streetName}
                    onChange={handleStreetNameChange}
                    className="form-controll"
                    maxLength={32}
                    required
                  />
                </div>

                <div>
                  <label htmlFor="floorNumber">Floor Number</label>
                  <input
                    type="text"
                    id="floorNumber"
                    name="floorNumber"
                    value={floorNumber}
                    onChange={handleFloorNumberChange}
                    className="form-controll"
                    maxLength={3}
                  />
                </div>

                <div>
                  <label htmlFor="unitNumber">Unit Number</label>
                  <input
                    type="text"
                    id="unitNumber"
                    name="unitNumber"
                    value={unitNumber}
                    onChange={handleUnitNumberChange}
                    className="form-controll"
                    maxLength={5}
                  />
                </div>

                <div>
                  <label htmlFor="buildingName">Building Name</label>
                  <input
                    type="text"
                    id="buildingName"
                    name="buildingName"
                    value={buildingName}
                    onChange={handleBuildingNameChange}
                    className="form-controll"
                    maxLength={66}
                  />
                </div>

                <div>
                  <label htmlFor="postalCode">
                    Postal Code<span className="star-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="postalCode"
                    name="postalCode"
                    value={postalCode}
                    onChange={handlePostalCodeChange}
                    className="form-controll"
                    maxLength={6}
                    required
                  />
                </div>

                <div>
                  <label htmlFor="country">
                    Country<span className="star-red">*</span>
                  </label>
                  <select
                    id="country"
                    name="country"
                    value={country}
                    className="form-controll"
                    onChange={handleCountryChange}
                    required
                  >
                    {" "}
                    <option value="" disabled hidden>
                      Choose a Country
                    </option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.name}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label htmlFor="state">
                    State<span className="star-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="state"
                    name="state"
                    value={state}
                    onChange={handleStateChange}
                    className="form-controll"
                    maxLength={32}
                  />
                </div>
              </div>

              <div className="inst-cntt">
                <h2>Exporter Details</h2>
                <label htmlFor="exporterName">
                  Exporter Name<span className="star-red">*</span>
                </label>
                <input
                  type="text"
                  id="exporterName"
                  name="exporterName"
                  value={exporterName}
                  onChange={handleExporterNameChange}
                  className="form-controll"
                  maxLength={255}
                  required
                />
              </div>

              <div className="inst-cntt ">
                <h2>Application Details</h2>
                <label htmlFor="consignmentDescription">
                  Consignment Description<span className="star-red">*</span>
                </label>
                <textarea
                  id="consignmentDescription"
                  name="consignmentDescription"
                  value={consignmentDescription}
                  onChange={handleConsignmentDescriptionChange}
                  className="form-controll"
                  maxLength={255}
                  required
                />

                <div>
                  <label htmlFor="category">
                    Category<span className="star-red">*</span>
                  </label>
                  <select
                    id="category"
                    name="category"
                    value={category}
                    className="form-controll"
                    onChange={handleCategoryChange}
                    required
                  >
                    <option value="" disabled hidden>
                      Choose a Category
                    </option>
                    <option value="Aquarium Plants">Aquarium Plants</option>
                    <option value="Cactus">Cactus</option>
                    <option value="Cut Flowers">Cut Flowers</option>
                    <option value="Foliages">Foliages</option>
                    <option value="Orchid Plants">Orchid Plants</option>
                    <option value="Ornamental Plants">Ornamental Plants</option>
                    <option value="Seeds">Seeds</option>
                    <option value="Plant Products">Plant Products</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="botanicalNames">
                    Botanical or Common name of Plant/Product
                    <span className="star-red">*</span>
                  </label>
                  {botanicalNames.map((botanicalName, index) => (
                    <input
                      key={index}
                      type="text"
                      value={botanicalName}
                      onChange={(event) =>
                        handleBotanicalNameChange(index, event)
                      }
                      className="form-controll"
                      maxLength={255}
                      required
                    />
                  ))}
                  <button type="button" onClick={addBotanicalNameField}>
                    Add Botanical Name
                  </button>
                </div>

                <div>
                  <label htmlFor="quantity">
                    Quantity<span className="star-red">*</span>
                  </label>
                  <input
                    type="text"
                    id="quantity"
                    name="quantity"
                    value={quantity}
                    onChange={handleQuantityChange}
                    className="form-controll"
                    maxLength={6}
                    required
                  />
                </div>

                <div>
                  <label htmlFor="unitOfMeasurements">
                    Unit of Measurements<span className="star-red">*</span>
                  </label>
                  <select
                    id="unitOfMeasurements"
                    name="unitOfMeasurements"
                    value={unitOfMeasurements}
                    className="form-controll"
                    onChange={handleUnitOfMeasurementsChange}
                    required
                  >
                    <option value="" disabled hidden>
                      Choose a Unit of Measurement
                    </option>
                    <option value="Kilograms">Kilograms</option>
                    <option value="Number">Number</option>
                    <option value="Pieces">Pieces</option>
                    <option value="Stalks">Stalks</option>
                    <option value="Box/Carton">Box/Carton</option>
                    <option value="Bottle">Bottle</option>
                    <option value="Container">Container</option>
                    <option value="Grams">Grams</option>
                    <option value="Tonne">Tonne</option>
                    <option value="Packet">Packet</option>
                    <option value="Flask">Flask</option>
                  </select>
                </div>

                <div>
                  <label htmlFor="countryOfOrigin">
                    Country of Origin<span className="star-red">*</span>
                  </label>
                  <select
                    id="countryOfOrigin"
                    name="countryOfOrigin"
                    value={countryOfOrigin}
                    className="form-controll"
                    onChange={handleCountryOfOriginChange}
                    required
                  >
                    <option value="" disabled hidden>
                      Choose a Country of Origin
                    </option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.name}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label htmlFor="parcelReferences">
                    Parcel References / Tracking Numbers
                    <span className="star-red">*</span>
                  </label>
                  {parcelReferences.map((parcelReference, index) => (
                    <input
                      key={index}
                      type="text"
                      value={parcelReference}
                      onChange={(event) =>
                        handleParcelReferenceChange(index, event)
                      }
                      className="form-controll"
                      maxLength={66}
                      required
                    />
                  ))}
                  <button type="button" onClick={addParcelReferenceField}>
                    Add Parcel Reference
                  </button>
                </div>

                <div>
                  <label htmlFor="arrivalDate">
                    Arrival Date<span className="star-red">*</span>
                  </label>
                  <input
                    type="datetime-local"
                    id="arrivalDate"
                    name="arrivalDate"
                    value={arrivalDate}
                    onChange={handleArrivalDateChange}
                    className="form-controll"
                    required
                    min={getFormattedCurrentDateTime()}
                    max={new Date(
                      new Date().getTime() + 2 * 24 * 60 * 60 * 1000
                    )
                      .toISOString()
                      .slice(0, 16)}
                  />
                  {!isDateValid(arrivalDate) && (
                    <p className="error-message">
                      Arrival date must be within 2 days from the current date.
                    </p>
                  )}
                </div>
                <div>
                  <div className="inst-cntt mt-2">
                    <label className="form-check-label">
                      <h6>
                        {" "}
                        Extensions allowed for files:{" "}
                        {allowedExtensions.join(", ")}
                      </h6>
                    </label>
                    <span>
                      PC from Origin
                      <span className="star-red">*</span>
                    </span>
                    <br />
                    <div>
                      <div>
                        <input
                          type="file"
                          className="form-checked"
                          accept={allowedExtensions
                            .map((ext) => `.${ext}`)
                            .join(",")}
                          onChange={(e) => handleFileChange(e, setPcFromOrigin)}
                        />
                        {PcFromOrigin && (
                          <div>
                            <strong className="greenText">
                              Selected Pc From Origin File:
                            </strong>{" "}
                            {PcFromOrigin.name}
                          </div>
                        )}
                      </div>

                      <br />
                      <div>
                        <span>Invoice or Cites</span>
                        <br />
                        <input
                          type="file"
                          accept={allowedExtensions
                            .map((ext) => `.${ext}`)
                            .join(",")}
                          onChange={(e) => handleFileChange(e, setInvoice)}
                        />
                        {Invoice && (
                          <div>
                            <strong className="greenText">
                              Selected Invoice or Cites File:
                            </strong>{" "}
                            {Invoice.name}
                          </div>
                        )}
                      </div>
                      <br />
                    </div>
                  </div>
                </div>
                <div className="inst-cntt mt-2">
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={site_Key}
                    onChange={() => setIsCaptchaValid(true)}
                    onExpired={() => setIsCaptchaValid(false)}
                  />
                  {submitted && !isCaptchaValid && (
                    <div className="error-message">
                      Please complete the reCAPTCHA verification.
                    </div>
                  )}

                  <button type="submit">Submit</button>
                </div>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}

export default ApplicationForImportPermit;
